import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { useLocation, useRouteMatch } from 'react-router';
import useSWR from 'swr';
import { OutpostTenant } from '../../../../../../../typings/outpost';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import Loading from '../../../common/base/Loading';
import Tabs from '../../../common/base/Tabs';
import { Div } from '../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { TeamPermission } from '../../../contexts/TeamPermissionContext';
import { StyledViewContent, StyledViewNav, StyledViewNavHeader, StyledViewNavSecondary, StyledViewLayout, ViewBreadcrumbsTitle, StyledViewNavActions } from '../../../layouts/ViewLayout';
import NotFound from '../../DashboardScene/NotFound';
import { TenantMetrics } from './TenantMetrics';
import { TenantOverview } from './TenantOverview';
import { TenantSettings } from './TenantSettings';
import Button, { ButtonGroup } from '../../../common/base/Button';
import { useToasts } from '../../../common/Toast';
import { OutpostContext } from '../OutpostContext';
import { copyTextToClipboard } from '../../../../utils/copy';
const TenantView = t0 => {
  const $ = _c(63);
  const {
    id: id_prop,
    mutate_tenants
  } = t0;
  const {
    addToast
  } = useToasts();
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    status
  } = useContext(OutpostContext);
  const {
    pathname
  } = useLocation();
  const {
    params: t1
  } = useRouteMatch();
  const {
    id: id_param
  } = t1;
  const id = id_prop || id_param;
  let t2;
  if ($[0] !== id) {
    t2 = APIMethodKeys.outpost.tenants.get(id);
    $[0] = id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== HookdeckAPI.outpost.tenants || $[3] !== id) {
    t3 = () => HookdeckAPI.outpost.tenants.get(id);
    $[2] = HookdeckAPI.outpost.tenants;
    $[3] = id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: tenant,
    mutate,
    error
  } = useSWR(t2, t3);
  const current_status = pathname.endsWith("/settings") ? "settings" : pathname.endsWith("/metrics") ? "metrics" : "overview";
  const t4 = `/tenants/${id}`;
  let t5;
  if ($[5] !== t4) {
    t5 = {
      label: "Overview",
      key: "overview",
      to: t4
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `/tenants/${id}/metrics`;
  let t7;
  if ($[7] !== t6) {
    t7 = {
      label: "Metrics",
      key: "metrics",
      to: t6
    };
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = `/tenants/${id}/settings`;
  let t9;
  if ($[9] !== t8) {
    t9 = {
      label: "Settings",
      key: "settings",
      to: t8
    };
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t5 || $[12] !== t7 || $[13] !== t9) {
    t10 = {
      OVERVIEW: t5,
      METRICS: t7,
      SETTINGS: t9
    };
    $[11] = t5;
    $[12] = t7;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const TABS = t10 as const;
  let t11;
  if ($[15] !== mutate || $[16] !== mutate_tenants) {
    t11 = tenant_0 => {
      mutate(tenant_0);
      mutate_tenants?.();
    };
    $[15] = mutate;
    $[16] = mutate_tenants;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const mutate_all = t11;
  if (error?.status === 404) {
    let t12;
    if ($[18] !== id) {
      t12 = <NotFound title="Tenant not found" description="This tenant does not exist or has been deleted." id={id} />;
      $[18] = id;
      $[19] = t12;
    } else {
      t12 = $[19];
    }
    return t12;
  }
  if (error) {
    let t12;
    if ($[20] !== id) {
      t12 = <NotFound title="Failed to load tenant" description="An unexpected error occurred. Please try again." id={id} />;
      $[20] = id;
      $[21] = t12;
    } else {
      t12 = $[21];
    }
    return t12;
  }
  if (!tenant) {
    let t12;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <Div m={{
        t: 8
      }}><Loading /></Div>;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    return t12;
  }
  let t12;
  if ($[23] !== id) {
    t12 = {
      label: id,
      highlight: true
    };
    $[23] = id;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const title_breadcrumb = t12;
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      label: "Tenants",
      to: "/tenants"
    };
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== title_breadcrumb) {
    t14 = [t13, title_breadcrumb];
    $[26] = title_breadcrumb;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  const breadcrumbs = t14;
  let t15;
  if ($[28] !== breadcrumbs) {
    t15 = <ViewBreadcrumbsTitle breadcrumbs={breadcrumbs} />;
    $[28] = breadcrumbs;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== HookdeckAPI.outpost.tenants || $[31] !== addToast || $[32] !== id || $[33] !== status?.portal_hostname) {
    t16 = status?.portal_hostname && <TeamPermission role="member"><ButtonGroup more_options={[{
        icon: "copy",
        label: "Copy portal URL",
        onClick: () => {
          HookdeckAPI.outpost.tenants.getPortal(id).then(portal => {
            copyTextToClipboard(portal.redirect_url);
            addToast("success", "Portal URL copied to clipboard");
          }).catch(() => {
            addToast("error", "Failed to open portal");
          });
        }
      }]}><Button.Permission outline={true} icon="portal" onClick={() => {
          HookdeckAPI.outpost.tenants.getPortal(id).then(_temp).catch(() => {
            addToast("error", "Failed to open portal");
          });
        }}>Open Portal</Button.Permission></ButtonGroup></TeamPermission>;
    $[30] = HookdeckAPI.outpost.tenants;
    $[31] = addToast;
    $[32] = id;
    $[33] = status?.portal_hostname;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16) {
    t17 = <StyledViewNavActions>{t16}</StyledViewNavActions>;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t15 || $[38] !== t17) {
    t18 = <StyledViewNavHeader>{t15}{t17}</StyledViewNavHeader>;
    $[37] = t15;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== TABS) {
    t19 = Object.values(TABS);
    $[40] = TABS;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== current_status || $[43] !== t19) {
    t20 = <StyledViewNavSecondary><Tabs active_tab={current_status} border={false} tabs={t19} /></StyledViewNavSecondary>;
    $[42] = current_status;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t18 || $[46] !== t20) {
    t21 = <StyledViewNav>{t18}{t20}</StyledViewNav>;
    $[45] = t18;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== current_status || $[49] !== tenant) {
    t22 = current_status === "overview" && <TenantOverview tenant={tenant} />;
    $[48] = current_status;
    $[49] = tenant;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== current_status || $[52] !== tenant) {
    t23 = current_status === "metrics" && <TenantMetrics tenant={tenant} />;
    $[51] = current_status;
    $[52] = tenant;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== current_status || $[55] !== mutate_all || $[56] !== tenant) {
    t24 = current_status === "settings" && <TenantSettings tenant={tenant} mutate={mutate_all} />;
    $[54] = current_status;
    $[55] = mutate_all;
    $[56] = tenant;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== t21 || $[59] !== t22 || $[60] !== t23 || $[61] !== t24) {
    t25 = <StyledViewLayout><StyledViewContent>{t21}{t22}{t23}{t24}</StyledViewContent></StyledViewLayout>;
    $[58] = t21;
    $[59] = t22;
    $[60] = t23;
    $[61] = t24;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  return t25;
};
export default TenantView;
function _temp(portal_0) {
  window.open(portal_0.redirect_url, "_blank", "noopener,noreferrer");
}